export const errorMessageFor = (errors, field) => {
  if (errors && errors[field]) {
    return errors[field].message;
  }
  return null;
};
